export class SetRegionFilter {
  public static readonly type = '[Tournament] Set Region Filter';
  constructor(public region: string) {}
}

export class SetFormatFilter {
  public static readonly type = '[Tournament] Set Format Filter';
  constructor(public format: string) {}
}
